const CACHE_KEY = 'storagebox_share_link_tokens_v1';

function readCache() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeCache(map) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(CACHE_KEY, JSON.stringify(map));
  } catch {
    /* ignore quota */
  }
}

export function rememberShareLinkToken(shareId, linkToken) {
  if (!shareId || !linkToken) return;
  const map = readCache();
  map[shareId] = linkToken;
  writeCache(map);
}

export function resolveShareLinkToken(share) {
  if (!share || share.kind !== 'link') return '';
  if (share.linkToken) return share.linkToken;
  if (!share.shareId) return '';
  const map = readCache();
  return map[share.shareId] || '';
}

export function buildStorageBoxShareLink(linkToken) {
  if (!linkToken || typeof window === 'undefined') return '';
  return `${window.location.origin}/storagebox/share/${encodeURIComponent(linkToken)}`;
}

export function buildStorageBoxShareLinkForShare(share) {
  const token = resolveShareLinkToken(share);
  return token ? buildStorageBoxShareLink(token) : '';
}
